import React, { ReactNode } from 'react';
import { Button } from 'devextreme-react/button';
import './CardAnalytics.scss';
import moment from 'moment';
import { LoadIndicator } from 'devextreme-react';

type CardProps = {
  title?: string;
  additionalHeaderContent?: ReactNode;
  contentClass: string;
  isLoading?: boolean;
  onRefreshClick?: () => void; // Callback para el botón de actualizar
  lastUpdate?: string; // Fecha de última actualización
};

export const CardAnalytics = ({ title, contentClass, isLoading = false, children, additionalHeaderContent, onRefreshClick, lastUpdate }: React.PropsWithChildren<CardProps>) => (
  <div className={`card ${contentClass}`}>
    <div className='header'>
      {title && (
        <div className='title'>
          <div className='text'>{title}</div>
          {lastUpdate && <div className='update-text'>Actualizado: {moment(lastUpdate).format('hh:mm:ss a')}</div>}
        </div>  
      )}

      {additionalHeaderContent}
      {onRefreshClick && <Button type='default' icon='refresh' stylingMode='text' onClick={onRefreshClick} className='refresh-button' />}
    </div>
    {isLoading && (
      <div className='loading centered'>
        <LoadIndicator />
      </div>
    )}

    {!isLoading && <div className='card-contents'>{children}</div>}
  </div>
);
